import type { ForqEvent } from '@forq/contracts';

type EventHandler<TPayload = unknown> = (event: ForqEvent<TPayload>) => void;

export class EventBus {
  private readonly handlers = new Map<string, Set<EventHandler>>();

  subscribe<TPayload>(type: string, handler: EventHandler<TPayload>): () => void {
    const handlers = this.handlers.get(type) ?? new Set<EventHandler>();
    handlers.add(handler as EventHandler);
    this.handlers.set(type, handlers);

    return () => {
      handlers.delete(handler as EventHandler);
      if (handlers.size === 0) {
        this.handlers.delete(type);
      }
    };
  }

  publish<TPayload>(event: ForqEvent<TPayload>): void {
    this.handlers.get(event.type)?.forEach((handler) => handler(event));
  }
}
